/* Parent Hax — Theme JS */
'use strict';

/* ── Mailchimp JSONP subscribe ──────────────────────────────── */
function phMailchimpSubscribe(email, fname, lname) {
  var base = window.PHMailchimp;
  if (!base || !email) return;
  var url = base.replace('/post?', '/post-json?');
  url += '&EMAIL=' + encodeURIComponent(email);
  if (fname) url += '&FNAME=' + encodeURIComponent(fname);
  if (lname) url += '&LNAME=' + encodeURIComponent(lname);
  var cbName = '__mc_cb_' + Date.now();
  url += '&c=' + cbName;
  window[cbName] = function() { delete window[cbName]; };
  var s = document.createElement('script');
  s.src = url;
  s.onerror = function() { s.parentNode && s.parentNode.removeChild(s); };
  document.head.appendChild(s);
  setTimeout(function() { s.parentNode && s.parentNode.removeChild(s); }, 6000);
}

document.addEventListener('DOMContentLoaded', () => {

  /* ── Scroll reveal ──────────────────────────────────────── */
  const revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    revealEls.forEach((el) => observer.observe(el));
  } else {
    // Fallback: show everything immediately
    revealEls.forEach((el) => el.classList.add('is-visible'));
  }

  /* ── AJAX form submission ────────────────────────────────── */
  document.querySelectorAll('.ph-ajax-form').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"]');
      const wrap      = form.closest('.ph-form-wrap');
      const successEl = wrap && wrap.querySelector('.form-success');
      const origText  = submitBtn.textContent.trim();

      submitBtn.disabled    = true;
      submitBtn.textContent = 'Sending…';

      try {
        await fetch(form.action || window.location.pathname, {
          method:  'POST',
          body:    new FormData(form),
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });

        // If fetch didn't throw, Shopify accepted the submission
        const emailEl  = form.querySelector('[name="contact[email]"]');
        const fnameEl  = form.querySelector('[name="contact[first_name]"]');
        const lnameEl  = form.querySelector('[name="contact[last_name]"]');
        phMailchimpSubscribe(
          emailEl  ? emailEl.value.trim()  : '',
          fnameEl  ? fnameEl.value.trim()  : '',
          lnameEl  ? lnameEl.value.trim()  : ''
        );

        if (successEl) {
          form.style.display      = 'none';
          successEl.style.display = 'block';
        } else {
          submitBtn.textContent      = 'Sent ✓';
          submitBtn.style.background = '#22c55e';
          submitBtn.style.color      = 'white';
        }
      } catch {
        submitBtn.disabled    = false;
        submitBtn.textContent = origText;
        // Show a friendly inline error
        const errEl = document.createElement('p');
        errEl.style.cssText = 'color:#e53e3e;font-size:.85rem;margin-top:.5rem;';
        errEl.textContent   = 'Something went wrong — please try again.';
        form.appendChild(errEl);
        setTimeout(() => errEl.remove(), 4000);
      }
    });
  });

});

/* ── Qty +/− buttons ───────────────────────────────────── */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.qty-btn');
  if (!btn) return;
  const input = btn.closest('.qty-wrap').querySelector('.qty-input');
  if (!input) return;
  const min = parseInt(input.min || '0', 10);
  let val = parseInt(input.value, 10) || 1;
  if (btn.dataset.action === 'plus') val += 1;
  if (btn.dataset.action === 'minus') val = Math.max(min, val - 1);
  input.value = val;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

/* ── Product gallery thumbnail swap ─────────────────────── */
document.addEventListener('click', (e) => {
  const thumb = e.target.closest('.product-gallery__thumb');
  if (!thumb) return;
  const mainImg = document.getElementById('MainProductImage');
  if (mainImg && thumb.dataset.src) {
    mainImg.src = thumb.dataset.src;
    document.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
  }
});
